/**
 * @fileoverview gRPC-Web generated client stub for acompanha.checkouts.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/checkouts/v1/checkouts.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.checkouts = {};
proto.acompanha.checkouts.v1 = require('./checkouts_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.checkouts.v1.ListCheckoutsRequest,
 *   !proto.acompanha.checkouts.v1.ListCheckoutsResponse>}
 */
const methodDescriptor_CheckoutsService_ListCheckouts = new grpc.web.MethodDescriptor(
  '/acompanha.checkouts.v1.CheckoutsService/ListCheckouts',
  grpc.web.MethodType.UNARY,
  proto.acompanha.checkouts.v1.ListCheckoutsRequest,
  proto.acompanha.checkouts.v1.ListCheckoutsResponse,
  /**
   * @param {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.checkouts.v1.ListCheckoutsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.checkouts.v1.ListCheckoutsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.checkouts.v1.ListCheckoutsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient.prototype.listCheckouts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/ListCheckouts',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_ListCheckouts,
      callback);
};


/**
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.checkouts.v1.ListCheckoutsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient.prototype.listCheckouts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/ListCheckouts',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_ListCheckouts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.checkouts.v1.GetCheckoutRequest,
 *   !proto.acompanha.checkouts.v1.GetCheckoutResponse>}
 */
const methodDescriptor_CheckoutsService_GetCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.checkouts.v1.CheckoutsService/GetCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.checkouts.v1.GetCheckoutRequest,
  proto.acompanha.checkouts.v1.GetCheckoutResponse,
  /**
   * @param {!proto.acompanha.checkouts.v1.GetCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.checkouts.v1.GetCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.checkouts.v1.GetCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.checkouts.v1.GetCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient.prototype.getCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/GetCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_GetCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.checkouts.v1.GetCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient.prototype.getCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/GetCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_GetCheckout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.checkouts.v1.CreateCheckoutRequest,
 *   !proto.acompanha.checkouts.v1.CreateCheckoutResponse>}
 */
const methodDescriptor_CheckoutsService_CreateCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.checkouts.v1.CheckoutsService/CreateCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.checkouts.v1.CreateCheckoutRequest,
  proto.acompanha.checkouts.v1.CreateCheckoutResponse,
  /**
   * @param {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.checkouts.v1.CreateCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.checkouts.v1.CreateCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.checkouts.v1.CreateCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient.prototype.createCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/CreateCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_CreateCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.checkouts.v1.CreateCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient.prototype.createCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/CreateCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_CreateCheckout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.checkouts.v1.UpdateCheckoutRequest,
 *   !proto.acompanha.checkouts.v1.UpdateCheckoutResponse>}
 */
const methodDescriptor_CheckoutsService_UpdateCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.checkouts.v1.CheckoutsService/UpdateCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.checkouts.v1.UpdateCheckoutRequest,
  proto.acompanha.checkouts.v1.UpdateCheckoutResponse,
  /**
   * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.checkouts.v1.UpdateCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.checkouts.v1.UpdateCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.checkouts.v1.UpdateCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient.prototype.updateCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/UpdateCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_UpdateCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.checkouts.v1.UpdateCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient.prototype.updateCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/UpdateCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_UpdateCheckout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.checkouts.v1.DeleteCheckoutRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_CheckoutsService_DeleteCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.checkouts.v1.CheckoutsService/DeleteCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.checkouts.v1.DeleteCheckoutRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient.prototype.deleteCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/DeleteCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_DeleteCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient.prototype.deleteCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/DeleteCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_DeleteCheckout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.checkouts.v1.QuickCheckoutRequest,
 *   !proto.acompanha.checkouts.v1.QuickCheckoutResponse>}
 */
const methodDescriptor_CheckoutsService_QuickCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.checkouts.v1.CheckoutsService/QuickCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.checkouts.v1.QuickCheckoutRequest,
  proto.acompanha.checkouts.v1.QuickCheckoutResponse,
  /**
   * @param {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.checkouts.v1.QuickCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.checkouts.v1.QuickCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.checkouts.v1.QuickCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.checkouts.v1.CheckoutsServiceClient.prototype.quickCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/QuickCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_QuickCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.checkouts.v1.QuickCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.checkouts.v1.CheckoutsServicePromiseClient.prototype.quickCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.checkouts.v1.CheckoutsService/QuickCheckout',
      request,
      metadata || {},
      methodDescriptor_CheckoutsService_QuickCheckout);
};


module.exports = proto.acompanha.checkouts.v1;

